import { render } from "./CrearFormulario.vue?vue&type=template&id=76320d92&scoped=true"
import script from "./CrearFormulario.vue?vue&type=script&lang=js"
export * from "./CrearFormulario.vue?vue&type=script&lang=js"

import "./CrearFormulario.vue?vue&type=style&index=0&id=76320d92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76320d92"]])

export default __exports__